import { FaroButton } from "@faro-lotv/flat-ui";
import { Grid } from "@mui/material";
import { Children, PropsWithChildren, type JSX } from "react";

export type FilterMenuRowProps = {
  /** True if the filter menu row should be visible */
  isVisible: boolean;

  /** If true, the reset all button will be shown. */
  showResetButton?: boolean;

  /** If true, some filters are active and some UI elements are adjusted accordingly. */
  hasFilters?: boolean;

  /** Method that will be called when the reset all button is pressed */
  onClearFilters?(): void;
};

/** @returns the row of filter menus for the annotation list */
export function FilterMenuRow({
  isVisible,
  showResetButton,
  hasFilters,
  children,
  onClearFilters,
}: PropsWithChildren<FilterMenuRowProps>): JSX.Element {
  return (
    <Grid
      container
      spacing={0.5}
      sx={{
        my: 0,
        height: isVisible ? "auto" : 0,
        transition: "height 0.25s ease-in",
        transitionBehavior: "allow-discrete",
        overflowX: "hidden",
        overflowY: "clip",
        "&:hover": {
          overflowX: "auto",
        },
      }}
    >
      {Children.map(children, (child) => (
        <Grid size="auto">{child}</Grid>
      ))}

      {showResetButton && hasFilters && (
        <Grid size="auto">
          <FaroButton variant="ghost" onClick={onClearFilters} size="xs">
            Reset all
          </FaroButton>
        </Grid>
      )}
    </Grid>
  );
}
